import $ from "jquery";

const ATTR_TITLE = "jsAccordionTitle";

const SELECTOR_CONTAINER = '[data-js="jsAccordion"]';
const SELECTOR_TITLE = `[data-js="${ATTR_TITLE}"]`;

// Adapted from: https://www.w3.org/TR/wai-aria-practices/examples/accordion/accordion.html

const setup = function (accordion) {
  // Allow for multiple accordion sections to be expanded at the same time
  const allowMultiple = accordion.hasAttribute("data-allow-multiple");
  // Allow for each toggle to both open and close individually
  const allowToggle =
    allowMultiple || accordion.hasAttribute("data-allow-toggle");

  // Create the array of toggle elements for the accordion group
  const triggers = Array.prototype.slice.call(
    accordion.querySelectorAll(SELECTOR_TITLE),
  );

  accordion.addEventListener("click", function (event) {
    const { target } = event;

    if (target.getAttribute("data-js") === ATTR_TITLE) {
      // Check if the current toggle is expanded.
      const isExpanded = target.getAttribute("aria-expanded") === "true";
      const active = accordion.querySelector('[aria-expanded="true"]');

      // without allowMultiple, close the open accordion
      if (!allowMultiple && active && active !== target) {
        // Set the expanded state on the triggering element
        active.setAttribute("aria-expanded", "false");
        // Hide the accordion sections, using aria-controls to specify the desired section
        document
          .getElementById(active.getAttribute("aria-controls"))
          .setAttribute("hidden", "");

        // When toggling is not allowed, clean up disabled state
        if (!allowToggle) {
          active.removeAttribute("aria-disabled");
        }
      }

      if (!isExpanded) {
        // Set the expanded state on the triggering element
        target.setAttribute("aria-expanded", "true");
        // Hide the accordion sections, using aria-controls to specify the desired section
        document
          .getElementById(target.getAttribute("aria-controls"))
          .removeAttribute("hidden");

        // If toggling is not allowed, set disabled state on trigger
        if (!allowToggle) {
          target.setAttribute("aria-disabled", "true");
        }
      } else if (allowToggle && isExpanded) {
        // Set the expanded state on the triggering element
        target.setAttribute("aria-expanded", "false");
        // Hide the accordion sections, using aria-controls to specify the desired section
        document
          .getElementById(target.getAttribute("aria-controls"))
          .setAttribute("hidden", "");
      }

      event.preventDefault();
    }
  });

  // Bind keyboard behaviors on the main accordion container
  accordion.addEventListener("keydown", function (event) {
    const { target } = event;
    const key = event.which.toString();

    // 33 = Page Up, 34 = Page Down
    const ctrlModifier = event.ctrlKey && key.match(/33|34/);

    // Is this coming from an accordion header?
    if (target.getAttribute("data-js") === ATTR_TITLE) {
      // Up/ Down arrow and Control + Page Up/ Page Down keyboard operations
      // 38 = Up, 40 = Down
      if (key.match(/38|40/) || ctrlModifier) {
        const index = triggers.indexOf(target);
        const direction = key.match(/34|40/) ? 1 : -1;
        const { length } = triggers;
        const newIndex = (index + length + direction) % length;

        triggers[newIndex].focus();

        event.preventDefault();
      } else if (key.match(/35|36/)) {
        // 35 = End, 36 = Home keyboard operations
        switch (key) {
          // Go to first accordion
          case "36":
            triggers[0].focus();
            break;
          // Go to last accordion
          case "35":
            triggers[triggers.length - 1].focus();
            break;
        }
        event.preventDefault();
      }
    }
  });

  // These are used to style the accordion when one of the buttons has focus
  accordion.querySelectorAll(SELECTOR_TITLE).forEach(function (trigger) {
    trigger.addEventListener("focus", function (event) {
      accordion.classList.add("focus");
    });

    trigger.addEventListener("blur", function (event) {
      accordion.classList.remove("focus");
    });
  });

  // Minor setup: will set disabled state, via aria-disabled, to an
  // expanded/ active accordion which is not allowed to be toggled close
  if (!allowToggle) {
    // Get the first expanded/ active accordion
    const expanded = accordion.querySelector('[aria-expanded="true"]');

    // If an expanded/ active accordion is found, disable
    if (expanded) {
      expanded.setAttribute("aria-disabled", "true");
    }
  }
};

const init = function () {
  $(SELECTOR_CONTAINER).each(function () {
    setup(this);
  });
};

$(function () {
  init();
});

$(document).on("storybook:component:change", function () {
  init();
});
